export default __webpack_public_path__ + "static/media/chip_50.e5cb4256.svg";